/**
 * @file UserInfoModal.js
 * @author Jonas Matulis
 * @created 2024-XX-XX
 * @modified
 * @description file containing UserInfoModal component
 */

/**
 * UserInfoModal component displays user information in a modal.
 *
 * @param {Object} props - The component properties
 * @param {Object} props.selectedUser - The user object containing details to display.
 * @param {Function} props.setSelectedUser - Function to clear the selected user.
 *
 * @returns {JSX.Element | null} The rendered modal or null if no user is selected.
 */
const UserInfoModal = ({ selectedUser, setSelectedUser }) => {
  if (!selectedUser) return null;

  /**
   * Closes the modal by clearing the selected user.
   */
  const closeModal = () => setSelectedUser(null);

  return (
    <div className="items-center justify-center bg-secondary rounded-xl px-10 py-6 overflow-scroll w-full">
      <h2 className="text-2xl font-semibold mb-4">@{selectedUser.username}</h2>
      <div className="flex items-center gap-4 mb-2">
        <img
          src={selectedUser.profilePicture}
          alt={`${selectedUser.username}'s profile`}
          className="rounded-full w-24 h-24 object-cover"
        />
        <p className="">"{selectedUser.bio || "No bio available."}"</p>
      </div>
      <div className="flex w-full">
        <button
          className="ml-auto mt-4 px-4 py-2 bg-red-500 text-white rounded-lg"
          onClick={closeModal}
        >
          Close
        </button>
      </div>
      {/* Add other user details here */}
    </div>
  );
};

export default UserInfoModal;
